import { filter } from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { getProgressReportByStdId } from "../../../core/service/progressReport.service";
// material
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  CardHeader,
  TableContainer,
  TablePagination
} from "@mui/material";

// components
import Label from "../../Label";
import UserListHead from "./userTable/UserListHead";

const TABLE_HEAD = [
  { id: "created_date", label: "Date", alignRight: false },
  { id: "form_nm", label: "Report", alignRight: false },
  { id: "admin_approve", label: "Status", alignRight: false },
  { id: "email", label: "Email", alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis?.map((el) => el[0]);
}

export default function TableActivityProgressReport() {
  const { user: currentUser } = useSelector((state) => state.authReducer);
  const { id: std_id } = currentUser;
  const { user: anotherUser, isClickAnotherProfile } = useSelector(
    (state) => state.userProfileReducer
  );

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [listActivityProgressReport, SetListActivityProgressReport] = useState(
    []
  );

  const getReportById = async (std_id) => {
    const data = await getProgressReportByStdId(std_id);
    if (Array.isArray(data)) {
      SetListActivityProgressReport(data);
    }
  };
  const getReportByAnotherId = async (id) => {
    const data = await getProgressReportByStdId(id);
    if (Array.isArray(data)) {
      SetListActivityProgressReport(data);
    }
  };

  useEffect(() => {
    if (isClickAnotherProfile) {
      if (anotherUser) getReportByAnotherId(anotherUser?.id);
    } else getReportById(std_id);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0
      ? Math.max(
          0,
          (1 + page) * rowsPerPage - listActivityProgressReport.length
        )
      : 0;

  const filteredUsers = applySortFilter(
    listActivityProgressReport,
    getComparator(order, orderBy),
    filterName
  );

  return (
    <Card>
      <CardHeader title="Activity" sx={{ paddingBottom: 3 }} />
      <TableContainer sx={{ minWidth: 800, paddingTop: 3 }}>
        <Table>
          <UserListHead headLabel={TABLE_HEAD} />
          <TableBody>
            {filteredUsers
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, i) => {
                const {
                  admin_approve,
                  created_date,
                  email,
                  form_nm,
                  mentor_approve
                } = row;

                return (
                  <TableRow hover key={i} tabIndex={-1}>
                    <TableCell padding="checkbox" />
                    <TableCell>
                      {moment(created_date).format("DD/MM/YY")}
                    </TableCell>
                    <TableCell align="left">{form_nm}</TableCell>
                    <TableCell align="left">
                      <Label
                        variant="ghost"
                        color={
                          mentor_approve === 0 && admin_approve === 0
                            ? "warning"
                            : mentor_approve === 1
                            ? "success"
                            : admin_approve === 1
                            ? "success"
                            : "error"
                        }
                      >
                        {mentor_approve === 0 && admin_approve === 0
                          ? "Pending"
                          : mentor_approve === 1
                          ? "Approve"
                          : admin_approve === 1
                          ? "Approve"
                          : "Disapprove"}
                      </Label>
                    </TableCell>
                    <TableCell align="left">{email}</TableCell>
                  </TableRow>
                );
              })}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredUsers.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Card>
  );
}
